// This datadog logging is used to log errors that are thrown on the client side. to se serverside logging, check src/utils/logger.ts
import { datadogLogs } from '@datadog/browser-logs';
import { getAppEnv, isLocalHost } from '.';

export const datadogConfig = {
  prod: {
    clientToken: 'pub754cb05ff139e1ea6169bda51156e408',
  },
  stage: {
    clientToken: 'pub0070ea580b01ff852f3e7b50310b2844',
  },
  test: {
    clientToken: 'pub843198dada4eb2682d6e5c067f68951b',
  },
  dev: {
    clientToken: 'pub843198dada4eb2682d6e5c067f68951b',
  },
} as const;

export function initiateClientDatadogLogs(concent: boolean) {
  if (typeof window === 'undefined') return;

  const appEnv = getAppEnv().toLocaleLowerCase() as keyof typeof datadogConfig;

  if (!datadogConfig[appEnv]) return;

  // Datadog have test and dev under same environment
  const datadogAppEnv = appEnv === 'dev' || appEnv === 'test' ? 'test' : appEnv;
  const { clientToken } = datadogConfig[appEnv];
  datadogLogs.init({
    clientToken,
    trackingConsent: concent ? 'granted' : 'not-granted',
    site: 'datadoghq.eu',
    forwardErrorsToLogs: true,
    sessionSampleRate: 100,
    silentMultipleInit: true,
    service: 'ruter.no',

    proxy: (option: any) =>
      appEnv === 'prod'
        ? `https://logs-browser-intake-dd.transhub.io${option.path}?${option.parameters}`
        : `https://logs-browser-intake-dd.${datadogAppEnv}.transhub.io${option.path}?${option.parameters}`,
  });
}
